import { IPagination, TBooleanInNumber, TTranslate } from './main';
import { MEASURE, MEASURE_NUTRIENT } from 'src/constants/main';

export enum PRODUCTS_SORT_COLUMN {
  NAME = 'name',
  CATEGORY = 'category',
  BRANCH = 'branch',
  SORT = 'sort',
  PRICE = 'price',
  OUT_OF_STOCK = 'out_of_stock',
  STATUS = 'status',
}

/**
 *
 * types from api:
 * get v4/products
 * get v4/products/{id}
 *
 */

export enum PRODUCT_TYPE {
  PRODUCT,
  DEAL_COMBO,
  MEAL_COMBO,
}

export interface IProductV4 {
  id: number;
  external_id?: string | number;
  order_type: DELIVERY_ORDER_TYPE;
  name: TTranslate;
  description?: TTranslate;
  price: string; // float number
  calories: Calories;
  weight: string; // float number
  unit: MEASURE;
  unit_name?: MEASURE | null;
  type?: PRODUCT_TYPE;
  //
  image: string;
  images?: string[];
  //
  category?: {
    id: number;
    external_id?: string | null;
    name: TTranslate;
    status?: TBooleanInNumber;
    is_delete?: TBooleanInNumber;
  };
  category_id?: number;
  category_external_id?: string;
  min_quantity: number;
  quantity?: number;
  sort?: number | string; // display direction in foodics
  earn?: number; // from the point system
  redeem?: number; // from the point system
  upsales_items: number[];
  //
  is_size: TBooleanInNumber;
  size: IProductV4Size | null;
  sizes: IProductV4Size[];
  //
  is_modifiers: TBooleanInNumber;
  is_required_modifiers?: TBooleanInNumber;
  modifiers: IProductV4Modifier[];
  //
  is_exclusions: TBooleanInNumber;
  exclusions: IProductV4Exclusion[];
  //
  is_donation?: TBooleanInNumber;
  is_favorite?: TBooleanInNumber;
  out_of_stock: TBooleanInNumber;
  is_delete: TBooleanInNumber;
  status: TBooleanInNumber;
  // used on page for creating/editing items
  is_draft?: boolean;
  apply_item_price_to_all?: TBooleanInNumber;
  apply_modifier_price_to_all?: TBooleanInNumber;
  apply_item_option_status_to_all?: TBooleanInNumber;
  apply_availability_to_all?: TBooleanInNumber;
  only_for_combo?: TBooleanInNumber;
  allergens: { id: number }[];
  nutrients: IProductNutrient | null;
  nutrient: IProductNutrient | null;
}

export interface IProductV4Modifier {
  id: number;
  name: TTranslate;
  external_id?: string | null;
  sort?: number;
  minimum: number;
  maximum: number;
  options: IProductV4ModifierOption[];
  required?: TBooleanInNumber;
  multi_choice: TBooleanInNumber;
  unique_options: TBooleanInNumber;
}

export interface IProductV4ModifierOption {
  id: number;
  name: TTranslate;
  external_id?: string | null;
  price: string; // float number
  menu_group_price?: string; // float number
  calories: Calories;
  weight: string; // float number
  selected?: boolean;
  unit: MEASURE;
  sort?: number;
  taxable: number;
  quantity?: number;
  minimum: number;
  maximum: number;
  is_default?: TBooleanInNumber;
  is_active?: TBooleanInNumber;
  status?: TBooleanInNumber;
  is_delete?: TBooleanInNumber;
}

export interface IProductV4Exclusion {
  id: number;
  external_id?: string | null;
  status: TBooleanInNumber;
  name: TTranslate;
}

export interface IProductV4Size {
  id?: number;
  name: TTranslate;
  external_id?: string | null;
  price: string; // float number
  menu_group_price?: string; // float number
  calories: Calories;
  weight: string; // float number
  unit: MEASURE;
  unit_name?: MEASURE | null;
  sort?: number;
}

export interface IProductNutrient {
  added_sugars_in_gram: number | null; // float number
  calories_in_kcal: number | null; // float number
  carbohydrate_in_gram: number | null; // float number
  cholesterol_in_milligram: number | null; // float number
  fiber_in_gram: number | null; // float number
  polyols_in_gram: number | null; // float number
  protein_in_gram: number | null; // float number
  salt_in_gram: number | null; // float number
  saturated_fat_in_gram: number | null; // float number
  serving_size: number | null;
  serving_unit?: MEASURE_NUTRIENT | null;
  sodium_in_milligram: number | null; // float number
  total_fat_in_gram: number | null; // float number
  total_sugars_in_gram: number | null; // float number
  trans_fat_in_gram: number | null; // float number
}

// v4/categories/products api

export interface ICategoriesWithProductsCategory {
  id: number;
  external_id?: number;
  name: TTranslate;
  description: TTranslate;
  items: IPagination<IProductV4>;
  status: TBooleanInNumber;
}

export interface ICategoriesWithProducts {
  menu_update: number;
  global_category_id: number;
  data: ICategoriesWithProductsCategory[];
}

export enum PRODUCT_ORDER_TYPE {
  DELIVERY = 0b100,
  PICKUP_CURBSIDE = 0b010,
  DINEIN = 0b001,
}

// delivery - 4, pickup/curbside - 2, dinein - 1; (can be sum of these)
export enum DELIVERY_ORDER_TYPE {
  DINEIN = 1,
  PICKUP_CURBSIDE = 2,
  PICKUP_CURBSIDE_DINEIN = 3,
  DELIVERY = 4,
  DELIVERY_DINEIN = 5,
  DELIVERY_PICKUP_CURBSIDE = 6,
  ALL = 7,
}

export type Calories = null | number;

export interface ICashbackInfo {
  id: number;
  percent: number;
  maximum: number;
  name: TTranslate;
  description: TTranslate;
}
